export enum VIEW_LAYER_LIFE_CYCLE {
  BEFORE_INIT = 'beforeinit',
  AFTER_INIT = 'afterinit',
  BEFORE_RENDER = 'beforerender',
  AFTER_RENDER = 'afterrender',
  BEFORE_CHANGE_DATA = 'beforechangedata',
  AFTER_CHANGE_DATA = 'afterchangedata',
}
